import { render, staticRenderFns } from "./announcementDetails.vue?vue&type=template&id=b8c1264c&scoped=true&"
import script from "./announcementDetails.vue?vue&type=script&lang=js&"
export * from "./announcementDetails.vue?vue&type=script&lang=js&"
import style0 from "./announcementDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./announcementDetails.vue?vue&type=style&index=1&id=b8c1264c&lang=less&scoped=true&"
import style2 from "./announcementDetails.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c1264c",
  null
  
)

export default component.exports